import { render, staticRenderFns } from "./Comics.vue?vue&type=template&id=607761d2&"
import script from "./Comics.vue?vue&type=script&lang=js&"
export * from "./Comics.vue?vue&type=script&lang=js&"
import style0 from "./Comics.vue?vue&type=style&index=0&id=607761d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports